import { mapActions } from 'vuex';

export default {
  data() {
    return {
      url: null,
    };
  },
  created() {
    this.getIdUploadUrl()
      .then((data) => {
        this.url = data;
      });
  },
  methods: {
    ...mapActions('user', ['getIdUploadUrl']),
    onButtonClick() {
      window.location.href = this.url;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-upload-id/account-upload-id.js